// extracted by mini-css-extract-plugin
module.exports = {"mobileFooterWrapper":"MobilePageFrameFooter_mobileFooterWrapper__dD8Zd","mobileFooterV2Wrapper":"MobilePageFrameFooter_mobileFooterV2Wrapper__VOETe"};